<!-- Benutzer:innen-Dialog -->
<div
  class="main-content"
  style="display: flex; align-items: center; justify-content: space-between"
>
  <div>
    <h3>Alle Benutzer:innen</h3>
    <p-listbox
      listStyleClass="customListStyleClass"
      scrollHeight="auto"
      [options]="availableUsers"
      optionLabel="fullName"
      [(ngModel)]="selectedAvailableUsers"
      [multiple]="true"
      [filter]="true"
    ></p-listbox>
  </div>

  <div style="display: flex; flex-direction: column; gap: 0.5rem">
    <p-button icon="pi pi-angle-right" (click)="addUsers()" />
    <p-button icon="pi pi-angle-left" (click)="removeUsers()" />
  </div>

  <div>
    <h3>Kursteilnehmer:innen</h3>
    <p-listbox
      listStyleClass="customListStyleClass"
      scrollHeight="auto"
      [options]="courseUsers"
      optionLabel="fullName"
      [(ngModel)]="selectedCourseUsers"
      [multiple]="true"
      [filter]="true"
    />
  </div>
</div>

<div class="main-content form-buttons">
  <button
    pButton
    label=""
    type="submit"
    icon="pi pi-save"
    class="p-button-success"
    (click)="updateCourseWithUserlist()"
  ></button>
  <button
    pButton
    label="Abbrechen"
    icon="pi pi-times"
    class="p-button-secondary"
    (click)="closeDialog()"
  ></button>
</div>
